import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { cn } from "../../lib/utils";
import { Input } from "../../components/ui/input";
import { Button } from "../../components/ui/button";
import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import {
  UserLoginFormValues,
  UserLoginSchema,
} from "../../components/forms/User/user-zod-schema";
import { PasswordToggle } from "../../../src/lib/showPassword";
import { handleLogin } from "../../API/Users/authService";
import img from "../../images/auth.png";
import { useAuth } from "../../../src/contexts/AuthContext";

const Login = () => {
  const { getCurrentUser } = useAuth();
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const onSubmit = async () => {
    setLoading(true);
    const formData = form.getValues();
    try {
      await handleLogin(formData, form.setValue, UserLoginSchema, navigate);
      await getCurrentUser();
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  const form = useForm<UserLoginFormValues>({
    resolver: zodResolver(UserLoginSchema),
  });

  return (
    <div>
      {" "}
      <div className="relative flex-col items-center justify-center h-screen md:grid lg:max-w-none lg:grid-cols-2 lg:px-0">
        <Link
          to="/examples/authentication"
          className={cn("absolute right-4 hidden top-4 md:right-8 md:top-8")}
        ></Link>
        <div className="relative flex-col hidden h-full p-10 text-white bg-muted dark:border-r lg:flex">
          <div
            className="absolute inset-0 bg-center bg-cover"
            style={{
              backgroundImage: `url(${img})`,
            }}
          />
        </div>
        <form
          className="flex items-center h-full p-4 lg:p-8"
          onSubmit={form.handleSubmit(onSubmit)}
        >
          <div className="mx-auto flex w-full flex-col justify-center space-y-6 sm:w-[350px]">
            <div className="flex flex-col space-y-2 text-center">
              <h1 className="text-2xl font-semibold tracking-tight">
                S'authentifier
              </h1>
            </div>
            <div className="relative">
              <Input
                type="email"
                placeholder="Adresse e-mail..."
                {...form.register("email")}
              />

              {form.formState.errors.email && (
                <span className="text-sm text-red-500">
                  {form.formState.errors.email.message}
                </span>
              )}
              <div className="relative mt-5">
                <Input
                  type={showPassword ? "text" : "password"}
                  placeholder="Mot de passe..."
                  {...form.register("password")}
                  className="pr-10"
                />
                <PasswordToggle
                  showPassword={showPassword}
                  setShowPassword={setShowPassword}
                  className="absolute inset-y-0 flex items-center "
                />
              </div>

              {form.formState.errors.password && (
                <span className="text-sm text-red-500">
                  {form.formState.errors.password.message}
                </span>
              )}
            </div>
            <Button type="submit" className="bg-primary" isLoading={loading}>
              Se connecter
            </Button>
            <p className="px-8 text-sm text-center text-muted-foreground">
              <Link to="/reset-password" className="text-primary">
                Mot de passe oublié ?
              </Link>{" "}
            </p>
          </div>
        </form>
      </div>
    </div>
  );
};

export default Login;
